import { useEvent } from "../../changelog-item-context";
import EntityLink from "../EntityLink";

import EventTitleWrapper, { ActionText } from "./EventTitleWrapper";

import { getItemLink } from "@/components/UnifiedRegistry/utils";
import { useUser } from "@/context/user-context";
import { ActionType, ChangelogEntry, Entity } from "@/queries";

const CreateEventTitle = () => {
  const event = useEvent<ChangelogEntry<ActionType.CREATE>>();

  const createdName = event.action_payload?.name;

  const workspaceId = useUser()?.activeWorkspaceId;

  const link = getItemLink(
    {
      id: event.entity_id,
      type: event.entity_type,
    } as Entity,
    workspaceId!,
  );

  return (
    <EventTitleWrapper>
      <ActionText>Created</ActionText>
      {createdName && <EntityLink type={event.entity_type} name={createdName} link={link} />}
    </EventTitleWrapper>
  );
};

export default CreateEventTitle;
